import React, { useState } from 'react';
import { Table, Button, ButtonGroup } from '../common';
import TAP from '../../models/entities/TAP';
import moment from 'moment';
import './ApprovalsTAPTableRow.css';
import TAPApprovals from '../TemporaryAccessPass/components/TAPApprovals';
import TemporaryAccessPasswordService from '../../services/TemporaryAccessPasswordService';
import { authenticatedUser } from '../../authentication/authModule';
import { UserRole } from '../../models/enums/UserRole';


interface ApprovalsTAPTableRowProps {
    tap: TAP;
    setEndModal: any;
    temporaryAccessPasswordService: TemporaryAccessPasswordService;
}

const ApprovalsTAPTableRow = ({ tap, setEndModal, temporaryAccessPasswordService }: ApprovalsTAPTableRowProps) => {

    const [loading, setLoading] = useState<boolean>(false);

    const handleCompleteTAP = async (tapId: number, approve: boolean) => {
        try {
            setLoading(true);
            setEndModal({
                visible: true,
                text: approve ? `Approving...` : 'Rejecting...',
                variant: 'default'
            });
            const response = await temporaryAccessPasswordService.completeTap(tapId, approve);
            setEndModal({ visible: false });
        }
        catch (err) {
            setEndModal({
                visible: true,
                text: `An error occurred when approving the TAP request. Please try again later.`,
                variant: 'error'
            });
        }
        setLoading(false);
    }

        return (
            <Table.Row>
                <Table.Cell className='wrapper'>
                            {moment(moment.utc(tap.createdTime)).local().format('DD/MM/YYYY, h:mm:ss a')}
                </Table.Cell>
                <Table.Cell className='em-u-text-align-center'>
                            {tap.requestor.displayName}
                </Table.Cell>
                <Table.Cell className='center-align'>
                <ButtonGroup>
                    <Button
                        variant="primary"
                        disabled={(authenticatedUser.isInRole(UserRole.ApprovalsViewer) && tap.approver?.id !== authenticatedUser.userId)}
                        onClick={() => handleCompleteTAP(tap.id, true)}
                    >Accept
                    </Button>
                    <Button
                        variant="secondary"
                        disabled={(authenticatedUser.isInRole(UserRole.ApprovalsViewer) && tap.approver?.id !== authenticatedUser.userId)}
                        onClick={() => handleCompleteTAP(tap.id, false)}
                    >Reject
                    </Button>
                </ButtonGroup>
                </Table.Cell>
            </Table.Row>
        );
    }

export default ApprovalsTAPTableRow;